import { render } from "./StationsList.vue?vue&type=template&id=2163a8ca&scoped=true"
import script from "./StationsList.vue?vue&type=script&lang=js"
export * from "./StationsList.vue?vue&type=script&lang=js"

import "./StationsList.vue?vue&type=style&index=0&id=2163a8ca&scoped=true&lang=scss"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2163a8ca"]])

export default __exports__